
document.addEventListener('scroll', function () {
    document.body.scrollTop = 0;
});


(function ($) {

    $(() => {

        let front_page_banner = $('.banner-hero.front_page_hero');
        let banner_height = front_page_banner.innerHeight();

        let startScroll = 0;
        let endScroll = banner_height - $(window).height() / 2;

        let circleJson = [
            {
                circle: $('.circle.c-coral.cc-1'),
                startTop: 48,
                startLeft: 81,
                endTop: 45.3,
                endLeft: 85,
            },
            {
                circle: $('.circle.c-coral.cc-2'),
                startTop: 44,
                startLeft: 73,
                endTop: 40,
                endLeft: 69,
            },
            {
                circle: $('.circle.c-coral.cc-3'),
                startTop: 46.5,
                startLeft: 82.5,
                endTop: 40.9,
                endLeft: 90.5,
            },
            {
                circle: $('.circle.c-coral.cc-4'),
                startTop: 11,
                startLeft: 40,
                endTop: 12,
                endLeft: 41,
            },
            {
                circle: $('.circle.c-coral.cc-5'),
                startTop: 51.5,
                startLeft: 86.5,
                endTop: 53.5,
                endLeft: 92.5,
            },
            {
                circle: $('.circle.c-coral.cc-6'),
                startTop: 51,
                startLeft: 73.5,
                endTop: 52.7,
                endLeft: 69.5,
            },
            {
                circle: $('.circle.c-coral.cc-7'),
                startTop: 31,
                startLeft: 71,
                endTop: 24,
                endLeft: 68,
            },
            {
                circle: $('.circle.c-coral.cc-8'),
                startTop: 39,
                startLeft: -2,
                endTop: 39,
                endLeft: -8,
            },
            {
                circle: $('.circle.c-coral.cc-9'),
                startTop: 64,
                startLeft: 63.5,
                endTop: 77,
                endLeft: 55,
            },
            {
                circle: $('.circle.c-blue.cb-1'),
                startTop: 48.7,
                startLeft: 74.2,
                endTop: 48.5,
                endLeft: 70.2,
            },
            {
                circle: $('.circle.c-blue.cb-2'),
                startTop: 56.5,
                startLeft: 55.5,
                endTop: 60,
                endLeft: 48.5,
            },
            {
                circle: $('.circle.c-blue.cb-3'),
                startTop: 53.5,
                startLeft: 74.5,
                endTop: 58.5,
                endLeft: 71,
            },
            {
                circle: $('.circle.c-blue.cb-4'),
                startTop: 39,
                startLeft: 68,
                endTop: 30,
                endLeft: 59.5,
            },
            {
                circle: $('.circle.c-blue.cb-5'),
                startTop: 53.5,
                startLeft: 93.5,
                endTop: 55,
                endLeft: 99.5,
            },
            {
                circle: $('.circle.c-blue.cb-6'),
                startTop: 65,
                startLeft: 75,
                endTop: 73,
                endLeft: 75,
            },
            {
                circle: $('.circle.c-blue.cb-7'),
                startTop: 25,
                startLeft: 28,
                endTop: 23,
                endLeft: 20,
            },
            {
                circle: $('.circle.c-blue.cb-8'),
                startTop: 60,
                startLeft: 86,
                endTop: 73,
                endLeft: 95,
            },
            {
                circle: $('.circle.c-blue.cb-9'),
                startTop: 41.5,
                startLeft: 78.5,
                endTop: 35.5,
                endLeft: 79,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-1'),
                startTop: 49.5,
                startLeft: 78.5,
                endTop: 51.5,
                endLeft: 78.5,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-2'),
                startTop: 51.5,
                startLeft: 69,
                endTop: 54.5,
                endLeft: 62,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-3'),
                startTop: 36.5,
                startLeft: 73.5,
                endTop: 32.5,
                endLeft: 71.5,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-4'),
                startTop: 44.2,
                startLeft: 84,
                endTop: 36,
                endLeft: 96,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-5'),
                startTop: 59.5,
                startLeft: 69.5,
                endTop: 67.5,
                endLeft: 63.5,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-6'),
                startTop: 30,
                startLeft: 86.5,
                endTop: 21,
                endLeft: 91.5,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-7'),
                startTop: 55.5,
                startLeft: 82,
                endTop: 61.5,
                endLeft: 87,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-8'),
                startTop: 46.5,
                startLeft: 63,
                endTop: 45.8,
                endLeft: 56,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-9'),
                startTop: 62,
                startLeft: 37.5,
                endTop: 66,
                endLeft: 28.5,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-10'),
                startTop: 78,
                startLeft: 71.5,
                endTop: 90,
                endLeft: 69.5,
            },
            {
                circle: $('.circle.c-coral-dark.ccd-11'),
                startTop: 75,
                startLeft: -4,
                endTop: 75,
                endLeft: -15,
            },
        ];


        // Function to change circle size
        const scrollDown = () => {
            for (let i = 0; i < circleJson.length; i++) {
                transformOnScroll(startScroll,
                    endScroll,
                    window.scrollY,
                    circleJson[i].circle,
                    circleJson[i].startTop,
                    circleJson[i].endTop,
                    circleJson[i].startLeft,
                    circleJson[i].endLeft);
            }
        }


        // Function to transform on scroll
        const transformOnScroll = (start, end, current, circle, eStartX, eEndX, eStartY, eEndY) => {
            let cPer = (current / end);
            let eDiffX = (eEndX - eStartX);
            let xPos = eStartX + (eDiffX * cPer);
            let eDiffY = (eEndY - eStartY);
            let yPos = eStartY + (eDiffY * cPer);

            circle.css('top', xPos + '%');
            circle.css('left', yPos + '%');
        }

        // Function for banner setting on load
        const bannerInIt = () => {
            $('.parallax-layer').css('display', 'block');
            $('.parallax-layer .circle').css('display', 'block');
            setTimeout(() => {
                $('.front_page_hero.banner-hero .content-wrapper').css('opacity', 1);
                $('.flip-container').css('opacity', 1);
            }, 100);

            $('body > .banner > .container').css('opacity', 1);
        }

        // On scroll
        $(window).on('scroll', function () {
            if ((window.scrollY < endScroll) && ($(window).width() > 768)) {
                scrollDown();
            }
        });

        bannerInIt();
    })

})($);



// WEBPACK FOOTER //
// ./scripts/vendor/banner-parallax.js